<template>
  <v-card v-if="isVisible" v-bind="$attrs">
    <v-system-bar>{{ person.role }} von</v-system-bar>
    <v-list v-for="(item, index) in items" :key="index">
      <v-divider v-if="index > 0"></v-divider>
      <ListItem title="Name">
        {{ item.firstName }} {{ item.lastName }}
        <v-btn
          icon
          :to="{ name: 'PersonContact', params: { id: item.id.toString() } }"
          ><v-icon>mdi-link</v-icon></v-btn
        >
      </ListItem>
      <ListItem title="Klasse" v-if="item.schoolClass">
        {{ item.schoolClass.code }}
      </ListItem>
      <ListItem v-if="item.town" title="Adresse">
        <PostalAddress :person="item" />
      </ListItem>
      <ListItem v-if="item.phoneMobile" title="Mobiltelefon">
        <PhoneNumber :value="item.phoneMobile" />
      </ListItem>
    </v-list>
  </v-card>
</template>
<script>
import { defineComponent } from "vue";
import ListItem from "@/components/ListItem.vue";
import PhoneNumber from "common/components/Person/PhoneNumber.vue";
import PostalAddress from "common/components/Person/PostalAddress.vue";
import StaticText from "common/components/StaticText.vue";

export default defineComponent({
  name: "ContactLegalGuardians",
  components: { ListItem, PhoneNumber, PostalAddress, StaticText },
  props: {
    person: { type: Object, default: null },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    hasPerson() {
      return this.person && this.person.id;
    },
    isVisible() {
      return this.hasPerson && this.items.length > 0;
    },
    showVisibilityInfo() {
      return this.$_isPerson(this.person);
    },
  },
  watch: {
    person() {
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (!this.hasPerson) return;
      this.items = await this.apiGet({
        resource: "person/legalguardian",
        id: this.person.id,
      });
    },
  },
});
</script>
